module.exports = __webpack_public_path__ + "fonts/Poppins-SemiBold.090bd61.ttf";